module.exports = __webpack_public_path__ + "static/media/checkbox-on-black.cda0929f.svg";